document.addEventListener('DOMContentLoaded', function () {

  /* Mobile Nav */
  const toggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  const overlay = document.getElementById('overlay');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      mobileNav.classList.add('open');
      overlay.classList.add('active');
    });
    document.querySelector('.mobile-nav-close')?.addEventListener('click', closeMenu);
    overlay.addEventListener('click', closeMenu);
  }
  function closeMenu() {
    mobileNav?.classList.remove('open');
    overlay.classList.remove('active');
  }

  /* Product gallery thumbnails */
  document.querySelectorAll('.product-thumbs img').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const main = document.querySelector('.product-gallery-main img');
      if (main) { main.src = this.src; main.srcset = ''; }
      document.querySelectorAll('.product-thumbs img').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* Variant buttons */
  document.querySelectorAll('.variant-opts').forEach(group => {
    group.querySelectorAll('.variant-opt').forEach(btn => {
      btn.addEventListener('click', function () {
        group.querySelectorAll('.variant-opt').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        const hiddenId = document.getElementById('variant-id');
        if (hiddenId && this.dataset.variantId) hiddenId.value = this.dataset.variantId;
      });
    });
  });

  /* Cart qty buttons */
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const display = this.closest('.qty-row').querySelector('.qty-num');
      let v = parseInt(display.textContent) || 1;
      if (this.dataset.action === 'minus') v = Math.max(1, v - 1);
      if (this.dataset.action === 'plus')  v = v + 1;
      display.textContent = v;
    });
  });

  /* Collection sort */
  const sortSelect = document.querySelector('.collection-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => { window.location = sortSelect.value; });
  }

  /* Sticky header shadow on scroll */
  window.addEventListener('scroll', () => {
    const header = document.querySelector('.site-header');
    if (header) header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.06)' : '';
  }, { passive: true });

});
